import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { Input } from 'reactstrap'

class DisplayBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string
  })

  render () {
    const { type, className, width, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading }) => <Input type='text' width = {width}
          className = {className} readOnly name={`view${name}`} id={`view${name}`} value={value} />}
      </FieldLayoutBox>
    )
  }
};

export const DisplayBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={DisplayBoxClass} /> } // eslint-disable-line
export default DisplayBox
